//
// Dimension.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseModel";
import "./DimensionUnit";

var Dimension = createModule("commons::Dimension", ["commons::PropertyOwner","commons::BaseModel"], EventDispatcher, [
    ,
    {
        unit: 4,
        value: 5,
    },
    ,
    ,
    {
        getScalarValueForUnit: [5,4,5,5],
        asPixels: [5],
    },
    {
        _create_s: [4,7],
        _create_nn: [4,5,4],
    },
    ,
    ["_create"]
]);
export default Dimension;
